import { videoApi } from '../../api/videos';
import { createCategorySlice } from './categorySlice';
import { createContentSlice } from './contentSlice';

const { slice, actions } = createContentSlice({
  name: 'videos',
  api: videoApi,
  hasPublish: true,
});

const categoryFactory = createCategorySlice({
  name: 'videoCategories',
  api: videoApi.categories,
});

export const videoReducer = slice.reducer;
export const videoActions = actions;

export const videoCategoryReducer = categoryFactory.slice.reducer;
export const videoCategoryActions = categoryFactory.actions;

export const selectVideos = (state) => state.videos.items;
export const selectVideosStatus = (state) => state.videos.status;
export const selectVideoCategories = (state) => state.videoCategories.items;
